import { Box, Card, CardMedia, Chip, Button, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../redux/store";
import {
  DisconnectApp,
  RequestTextGridSetUp,
} from "../../redux/features/integration-setting/integration-setting-slice";
import { useState } from "react";
import DeleteConfirmation from "../../layouts/delete-confirmation/DeleteConfirmation";
import { DisConnectMailbox } from "src/redux/features/mailBox/mailbox-slice";
import { text } from "stream/consumers";
import { TextGridStatus } from "src/types/company";

interface AppCardProps {
  appName: string;
  logo: string;
  connected: boolean;
  onClick: () => void;
  description: string;
  textGridStatus?: string;
}

const AppCard = ({
  appName,
  logo,
  connected,
  onClick,
  description,
  textGridStatus,
}: AppCardProps) => {
  const dispatch = useAppDispatch();
  const [disConnectApp, setDisconnectApp] = useState<boolean>(false);
  const mailBoxAuthData = useAppSelector(
    (state) => state.mailBoxSlice.mailBoxAuthData
  );
  const handleDisconnect = () => {
    if ((appName === "Gmail" || appName === "Outlook") && mailBoxAuthData) {
      dispatch(
        DisConnectMailbox({
          mailboxId: mailBoxAuthData.id,
        })
      );
    } else {
      dispatch(DisconnectApp({ appName }));
    }
  };

  return (
    <Card
      className="cardBox"
      sx={{
        maxWidth: "1024px",
        display: "flex",
        flexDirection: {
          md: "row",
          xs: "column",
        },
        alignItems: "center",
        gap: "36px",
        padding: "16px 32px",
      }}
    >
      <CardMedia
        component={"img"}
        image={logo || ""}
        sx={{ maxWidth: "324px", maxHeight: "190px" }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Chip
          color={connected ? "success" : "default"}
          label={connected ? "Live" : "No setup"}
          sx={{ width: "80px", borderRadius: "4px" }}
        />
        <Typography sx={{ lineHeight: "32px !important", fontSize: "18px" }}>
          {description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            width: "fit-content",
            alignSelf: "end",
          }}
        >
          {/* <Button
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
            onClick={onClick}
          >
            <Settings />
            Configure
          </Button> */}
          {appName === "TextGrid" ? (
            <>
              {/* <Button
                variant="outlined"
                onClick={() => window.open("https://forms.gle/PEzQjQepQNRAMW2U8", "_blank")}
              >
                Request setup
              </Button> */}
              {textGridStatus === TextGridStatus.Connected ? (
                <Button onClick={onClick} variant="contained">
                  Connected
                </Button>
              ) : textGridStatus === TextGridStatus.Requested ? (
                <Button 
                  // variant="contained" color="inherit"
                  variant="outlined"
                  onClick={() => window.open("https://forms.gle/PEzQjQepQNRAMW2U8", "_blank")}
                >
                  Setup Form
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    dispatch(RequestTextGridSetUp());
                    window.open("https://forms.gle/PEzQjQepQNRAMW2U8", "_blank");
                  }}
                  variant="contained"
                >
                  Setup Form
                </Button>
              )}
            </>
          ) : (
            <>
              {connected ? (
                <Button
                  onClick={() => setDisconnectApp(true)}
                  variant="outlined"
                >
                  Dis-Connect
                </Button>
              ) : (
                <Button onClick={onClick} variant="contained">
                  Connect
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
      {disConnectApp && (
        <DeleteConfirmation
          name={""}
          title="Are you sure you want to Dis-Connect ?"
          setModal={(value) => {
            if (value) {
              handleDisconnect();
            }
            setDisconnectApp(false);
          }}
        />
      )}
    </Card>
  );
};

export default AppCard;
